/**
 * Stepper Component - Constants
 * =============================
 */

import { getIcon } from '../../icons';

export type StepperSize = 'sm' | 'md';

export interface StepperSizeStyles {
  button: string;
  icon: string;
  value: string;
  label: string;
}

export interface StepperDefaultValues {
  size: StepperSize;
  min: number;
  max: number;
  step: number;
}

export const SIZES: Record<StepperSize, StepperSizeStyles> = {
  sm: { button: 'ec-w-6 ec-h-6', icon: 'ec-w-4 ec-h-4', value: 'ec-text-sm ec-min-w-[2ch]', label: 'ec-text-sm' },
  // md = spec Figma: pill con botones 24px, cantidad 14/18 en caja fija de 20px.
  md: { button: 'ec-w-6 ec-h-6', icon: 'ec-w-4 ec-h-4', value: 'ec-text-sm ec-w-5', label: 'ec-text-base' }
};

export const BASE_CLASSES = {
  wrapper: 'ec-flex ec-items-center ec-justify-between ec-gap-2',
  label: 'ec-text-color-text ec-flex-1',
  labelDisabled: 'ec-text-color-text-disabled',
  // Pill: fondo accent-subtle, gap 4px entre botones y cantidad.
  control: 'ec-inline-flex ec-items-center ec-justify-center ec-gap-1 ec-flex-shrink-0 ec-bg-color-accent-subtle ec-rounded-full ec-p-1',
  controlDisabled: 'ec-bg-color-fill-disabled',
  button:
    'ec-inline-flex ec-items-center ec-justify-center ec-rounded-full ec-transition-colors ' +
    'ec-bg-color-primary ec-text-color-primary-contrast hover:ec-bg-color-primary-dark ' +
    'focus-visible:ec-outline-none focus-visible:ec-ring-2 focus-visible:ec-ring-color-primary focus-visible:ec-ring-offset-1',
  buttonDisabled: 'ec-bg-gray ec-text-white ec-cursor-not-allowed hover:ec-bg-gray',
  value: 'ec-text-color-text ec-text-center ec-font-semibold ec-tabular-nums',
  valueDisabled: 'ec-text-color-text-disabled ec-font-normal'
};

/**
 * Iconos SVG predefinidos — valores del registro central (`src/icons`).
 */
export const ICONS = {
  minus: getIcon('minus') || '',
  plus: getIcon('plus') || ''
};

export const DEFAULTS: StepperDefaultValues = { size: 'md', min: 0, max: 99, step: 1 };
